<template>
  <div class="pb-2 pt-2 border-bottom">
    <div class="condition-line-label">{{label}}</div>
    <span class="selected-item-primary" v-for="item in items" :key="item">{{item}}</span>
  </div>
</template>
<script>
export default {
  data() {
    return {
  
    }
  },
  props: {
    label: {
      type: String,
      default: "項目"
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  components: {
  },
  methods: {
    
  },
  created(){
    
  },
  computed: {
    
  },
  watch: {
    
  }
}
</script>